import { useFATCATaxResidencies } from '../utils/useFATCATaxResidencies';

export const sendAndValidateOtherTaxationResidencies = async (
  entries: ReturnType<typeof useFATCATaxResidencies>['fatcaTaxResidencies'],
) => {
  const someAreMissingTINNumber: boolean = entries.some(
    (item) => item.tinAbsent || !item.tinCode,
  );

  if (someAreMissingTINNumber) {
    return { status: 'some_are_missing_tin_number' };
  }

  return { status: 'success' };
};
